export enum BotCommandActionTypeEnum {
  LINK = 'link',
  MESSAGE = 'message',
}

export const BotCommandActionTypeEnumLabels = {
  [BotCommandActionTypeEnum.LINK]: 'Link',
  [BotCommandActionTypeEnum.MESSAGE]: 'Mensagem',
}
